import { Skeleton, SkeletonProps } from "@mui/material";
import { useState } from "react";

type ImageSkeletonProps = {
  src: string;
  alt: string;
  height?: number;
  width?: number;
  skeletonProps?: SkeletonProps;
};

export const ImageSkeleton = ({
  src,
  alt,
  height,
  width,
  skeletonProps,
}: ImageSkeletonProps) => {
  const [imgLoaded, setImgLoaded] = useState<boolean>(false);
  return (
    <>
      {!imgLoaded && (
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={width}
          height={height}
          {...skeletonProps}
        />
      )}

      <img
        src={src}
        alt={alt || src}
        onLoad={() => setImgLoaded(true)}
        height={height}
        width={width}
        style={{ display: imgLoaded ? "inherit" : "none" }}
      />
    </>
  );
};
